import React from 'react'
import s from '../../css/profile/profileQuota.module.css'

const ACCOUNT_TYPES = {
	FREE: 'Бесплатный',
	EXTENDED: 'Расширенный',
	UNLIMITED: 'Безлимитный',
}

const UNLIMITED_VALUE = -1
const MAX_PERCENT = 100

const isUnlimited = ({ value }) => value === UNLIMITED_VALUE

const getPercent = ({ value, used }) =>
	value > 0 ? Math.min(MAX_PERCENT, (used / value) * MAX_PERCENT) : 0

const ProfileQuota = ({ quotaData, isQuotaError }) => {
	if (isQuotaError) {
		return (
			<section className={s.card}>
				<h3>Лимиты</h3>
				<p className={s.error}>Не удалось загрузить</p>
			</section>
		)
	}

	if (!quotaData) return null

	const { accountType, dailyQuota, totalQuota } = quotaData

	return (
		<section className={s.card}>
			<div className={s.header}>
				<h3>Лимиты</h3>
				<span className={s.badge}>
					{ACCOUNT_TYPES[accountType] || accountType}
				</span>
			</div>
			<div className={s.stat}>
				<div className={s.statRow}>
					<span className={s.label}>Запросов за сегодня</span>
					<span className={s.value}>
						{isUnlimited(dailyQuota)
							? `${dailyQuota.used} / без ограничений`
							: `${dailyQuota.used} / ${dailyQuota.value}`}
					</span>
				</div>
				{!isUnlimited(dailyQuota) && (
					<div className={s.bar}>
						<div
							className={s.barFill}
							style={{ width: `${getPercent(dailyQuota)}%` }}
						/>
					</div>
				)}
			</div>
			<div className={s.statRow}>
				<span className={s.label}>Запросов за всё время</span>
				<span className={s.value}>{totalQuota.used}</span>
			</div>
		</section>
	)
}

export default ProfileQuota
